export default __webpack_public_path__ + "user-21.svg";